export default __webpack_public_path__ + "static/media/985E3A5E-F192-4E46-8AFB-F50741ABF86E_1_105_c.59d4be9d.jpeg";